<template>
    <div class="popup-wrapper">
        <div class="mask">
            <div class="content">
                <wrapper column background-color="#ffffff" popup scrollable>
                    <div class="float image-container">
                        <img src="@/assets/Popup/top.png" alt="" width="100%" />
                        <div class="text" v-html="title" />
                    </div>
                    <div class="main">
                        <slot />
                    </div>
                    <slot name="dialog" />
                    <div class="hint">
                        <slot name="hint" />
                    </div>
                    <round-btn
                        shadow-color="rgba(171, 203, 216, 0.5)"
                        background-color="#56a1e6"
                        color="#ffffff"
                        font-size="1.8em"
                        height="70px"
                        width="80%"
                        style="margin: 20px auto"
                        @click="onConfirm"
                    >
                        <div class="button-content">確定</div>
                    </round-btn>
                    <slot name="extra-button" />
                    <div v-if="close" class="close" @click="$emit('close')">
                        <img
                            src="@/assets/Popup/close.png"
                            alt=""
                            width="100%"
                        />
                    </div>
                </wrapper>
            </div>
        </div>
    </div>
</template>

<script>
import wrapper from '@/components/Wrapper/MainWrapper.vue';

export default {
    props: {
        close: Boolean,
        title: String,
    },
    components: { wrapper },
    methods: {
        onConfirm() {
            this.$emit('confirm');
        },
    },
};
</script>

<style lang="scss" scoped>
.popup-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    .mask {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #000000af;
        .content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .wrapper .main {
                flex: 0.9;
                width: 80%;
            }
        }
        .hint {
            width: 80%;
        }
    }
    .close {
        cursor: pointer;
        position: absolute;
        top: 20px;
        right: 20px;
        width: 30px;
        height: 30px;
    }

    .image-container.float {
        position: relative;
        .text {
            font-size: 1.5em;
            font-weight: bold;
            color: #064269;
            position: absolute;
            top: 40%;
            left: 10%;
            transform: translateY(-50%);
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }
    .button-content {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
